import { render, staticRenderFns } from "./Rural.vue?vue&type=template&id=54bd025c&scoped=true&"
import script from "./Rural.vue?vue&type=script&lang=js&"
export * from "./Rural.vue?vue&type=script&lang=js&"
import style0 from "./Rural.vue?vue&type=style&index=0&id=54bd025c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bd025c",
  null
  
)

export default component.exports